import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px;
  height: 80px;
  align-items: center;
  box-sizing: border-box;
  background-color: #121214;
  width: 100%;
  color: #1e2029;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  letter-spacing: -0.01em;
`;

function PageHeader({
                      children,
                      color = "#121214",
                      header,
                      height = "80px",
                    }: IPageHeader) {
  return (
      <Wrapper style={{ backgroundColor: color, height: height }}>
        {header}
        {children}
      </Wrapper>
  );
}

export interface IPageHeader {
  header: string;
  children?: any;
  color?: string;
  height?: string;
}

export default PageHeader;
